import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'
import { useMemo } from 'react'
import { generateSrcFromEmail } from 'utils/avatar'
import { getUserNameSurname } from 'utils/user'
import { useModal } from 'providers/ModalProvider'
import { ProfileModal } from 'components/modals/ProfileModal'
import { Icon } from 'components/ui/Icon'
import { Col } from 'components/ui/Col'
import { useNavigate } from 'react-router'

export const ProfileAvatar = () => {
  const user = useSelector(settingsSelectors.userDetails)
  const avatar = useMemo(() => generateSrcFromEmail(user?.email), [user])
  const nameSurname = useMemo(() => getUserNameSurname(user), [user])

  const navigate = useNavigate()

  const { open } = useModal()

  if (!user)
    return (
      <Col
        justifyContent={'center'}
        alignItems={'center'}
        onClick={() => navigate('/login')}
        className={'tw-cursor-pointer tw-bg-primary-300'}
        style={{
          borderRadius: '50%',
        }}
        width={'2.5rem'}
        height={'2.5rem'}
      >
        <Icon icon={['fas', 'user']} />
      </Col>
    )

  return (
    <div
      onClick={() => {
        open(<ProfileModal />)
      }}
      className={'tw-cursor-pointer'}
    >
      <img
        alt={nameSurname}
        src={avatar}
        style={{
          height: '2.5rem',
          width: '2.5rem',
          borderRadius: '50%',
        }}
      />
    </div>
  )
}
